export const FETCH_VOTES = "app/VOTE/FETCH_VOTES";
export const FETCH_VOTES_SUCCESS = "app/VOTE/FETCH_VOTES_SUCCESS";
export const FETCH_VOTES_FAILURE = "app/VOTE/FETCH_VOTES_FAILURE";
